import { Component } from '@angular/core';
import { NavController, LoadingController, Platform } from 'ionic-angular';
import { MedicineStocklocPage } from '../medicine-stockloc/medicine-stockloc';
/* import { SQLite, SQLiteObject } from '@ionic-native/sqlite'; */
import { Subscription }  from 'rxjs/Subscription';
import { DataProvider } from '../../providers/data/data';
import { FormGroup, FormBuilder,  Validators } from '@angular/forms';
import { InAppBrowser } from '@ionic-native/in-app-browser';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  update_date: any = "2020-02-11 06:00:00"; //Version Update Date
  frmSignin: FormGroup;
  signInSubs: Subscription;
  username: string;
  password: string;
  name: string;

  searchItem: any = ""; 
  invmasSubs: Subscription;
  s_town: Subscription;
  s_province: Subscription;
  s_branches: Subscription;
  app_update: Subscription;
  _datatown: any[] = [];
  _dataprov: any[] = [];
  _databranch: any[] = [];
  _userdata: any[] = [];
  branchData: any[] = [];
  townrecord: any[] = [];
  transnumber: any;
  branchcode: any;
  branchname: any;
  towncode: any;
  provcode: any;
  createData: any;
  user: any;
  user_id: any;
  province: any;
  branch: any[] = [];
  startup: any;
  isWeb: any;
  isApp: any;


  _uemail: string;
  _upassword: string;
  _pcheck: string;

  loadingx = this.loadingCtrl.create({
    content:'Loading Data, please wait...',
    enableBackdropDismiss: true
  });

  constructor(
    public navCtrl: NavController,  
    /* private sqlite: SQLite, */
    private fb: FormBuilder,
    private dataProv: DataProvider,
    private iab: InAppBrowser,
    private loadingCtrl: LoadingController,
    private platform: Platform) {

    this.frmSignin = this.fb.group({
      _email: ['', Validators.required ],
      _password: ['', Validators.required ],
      credential: []
    });
  }

  ionviewDidLoad() {
    //this.loadingx.present();
  }

  showMedStockLoc() {    
    console.log("Start: "+this.towncode + " - " + this.provcode + " - " + this.createData + " - " +localStorage.getItem('s_brncname') + " - " + this.branchcode + " - " + this.name);
    if(this.searchItem === ""){
      alert("Please enter keyword.");
    }
    else{
      this.navCtrl.push(MedicineStocklocPage, { keyword: this.searchItem, towncode: this.towncode, provcode: this.provcode , user: this.user_id, branch: this.branchcode });
    } 
  }

  checkData(){
    if(localStorage.getItem('user_id')){
      this.branchname = localStorage.getItem('s_brncname');
      this.branchcode = localStorage.getItem('s_brnccode');
      this.towncode = localStorage.getItem('s_towncode');
      this.provcode = localStorage.getItem('s_provcode');
      this.transnumber = localStorage.getItem('s_trannmbr');
      this.startup = localStorage.getItem('startup');
      this.name = localStorage.getItem('name');
      this.user_id = localStorage.getItem('user_id');
      //this.lastname = localStorage.getItem('lastname');
      this.user = 'true';
      this.createData = 'false';
    }
    else{
     // console.log("Create Data");
      this.createData = 'true';
      this.startup = 'true';
      this.user = 'false';
      //this.checkbranches();
    }
    
    if(this.isWeb=='false'){
      this.app_update = this.dataProv.getAppVersion()
      .subscribe((rs: any[]) => {
        console.log(rs['app_update']);
        if(rs['app_update'] == this.update_date){
        }
        else{
          if(confirm("The App Version does not match with the current version. Please update your app. Thank you.")){
            this.downloadPage();
          }
          else{
          }
        }
      }, error => {
        //console.log('Network Connection Error: Failed to load Town.');
      }, function() {
      });
    }
  }

  getKeyword(ev: any) {
    let val = ev.target.value;
    this.searchItem = val;
    //console.log(val);
  }  

  editBranch(){
    this.createData = 'true';
  }

  cancel(){
    this.createData = 'false';
    this.navCtrl.setRoot(this.navCtrl.getActive().component);
  }

  ionViewDidEnter() {
    console.log('viewDidEnter homepage');
    this.isApp = (document.URL.startsWith('http'));
    console.log("PLATFORM:="+this.isApp);
    this.checkData();
    if (this.isApp){
      this.isWeb = 'true';
    }
    else{
      this.isWeb = 'false';
    }

  

  }
  ionViewWillLeave() {

  }
  ngOnDestroy() {
    if(this.invmasSubs) {
      this.invmasSubs.unsubscribe();
    }
    if(this.signInSubs) {
      this.signInSubs.unsubscribe();
    }
  }
  signIn() {
    console.log(this.username+ " - " + this.password);
    this.getInfoSignIn(this.username, this.password);
  }

  getInfoSignIn(emailAdd, upassword) {
    let load = this.loadingCtrl.create({
      content:'Checking user, please wait...',
      enableBackdropDismiss: true
    });
    load.present();
    this._userdata = [];
    this.signInSubs = this.dataProv.getLogin(emailAdd, upassword)
      .subscribe((datax: any[]) => {
        console.log(datax);
        this._userdata = datax;
        if(datax.length > 0){
        localStorage.setItem('s_brncname',this._userdata[0]['s_brncname']);
        localStorage.setItem('s_provcode',this._userdata[0]['s_provcode']);
        localStorage.setItem('s_towncode',this._userdata[0]['s_towncode']);
        localStorage.setItem('s_trannmbr',this._userdata[0]['s_trannmbr']);
        localStorage.setItem('s_brnccode',this._userdata[0]['s_brnccode']);
        localStorage.setItem('user_id',this._userdata[0]['id']);
        localStorage.setItem('username',this._userdata[0]['username']);
        localStorage.setItem('name',this._userdata[0]['name']);
        localStorage.setItem('startup','false');      
        localStorage.setItem('user','true');   
        this.checkData();
        this.loadingx.dismiss();   
        }
        else{
          alert("User does not exist, please check Username or Password. Don't have account? Contact Administrator for account.");
        }
      },
      () => {
        load.dismiss();
        alert('Internet Connection: Please check your internet connection or too slow internet connection')
      },
      function() {


        load.dismiss();
      }
      );
      console.log("ENTER");
  }  

  logoutuser(){
    let load = this.loadingCtrl.create({
      content:'Logging out...',
      enableBackdropDismiss: true
    });
    load.present();
    localStorage.clear();
    this._uemail = '';
    this._upassword = '';
    this.username = '';
    this.password = '';
    this.user = 'false';
    setTimeout(function(){
      load.dismiss();
    }, 2000); 
  }
  downloadPage() {
    // this.iab.create('http://demo.stjosephdrug.com/orderonline/catalogue','',{ location: 'no', hardwareback: 'yes' });
    this.iab.create('http://search.medfinder.stjosephdrug.com/download','',{ location: 'no', hardwareback: 'yes' })
  }

  
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts